import { CcfBox, CcfButton, CcfTypography } from '@nice-ccf/ui-controls';
import styles from './partner-access-control-header.module.scss';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { globalActions } from '../../global.app.slice';

/* eslint-disable-next-line */
export interface PartnerAccessControlHeaderProps {
  isTableOpen: any;
  setIsTableOpen: any;
  createUser: any;
  initialNewUserFeilds: any;
  setNewUserDetails: any;
  newUserDetails: any;
  errors: any;
  setErrors: any;
}

/**
 * Component displays PartnerAccessControlHeader
 * @param props -PartnerAccessControlHeaderProps
 * @returns app header component for landing screen
 * @example <PartnerAccessControlHeader/>
 */
export function PartnerAccessControlHeader(
  props: PartnerAccessControlHeaderProps
) {
  const dispatch = useDispatch();
  const {setShowPartnerAccessPage} = globalActions;
  const {
    setIsTableOpen,
    isTableOpen,
    createUser,
    initialNewUserFeilds,
    setNewUserDetails,
    newUserDetails,
    errors,
    setErrors,
  } = props;

  /**
   * @example
   */
  const goBack = () => {
    dispatch(setShowPartnerAccessPage(false));
  }
  return (
    <Grid
      style={{
        margin: '20px 50px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
      id="partnerAccessHeaderContainer"
    >
      <CcfBox display={'flex'} alignItems={'center'} gap={'10px'}>
        {isTableOpen && <CcfButton primary onClick={goBack}>Back</CcfButton>}
        <CcfTypography sx={{ fontWeight: '600', color: 'black' }}>
          {isTableOpen ? 'Partner Users' : 'Create User'}
        </CcfTypography>
      </CcfBox>
      {isTableOpen ? (
        <CcfBox style={{ display: 'flex', gap: '10px' }}>
          {/* <CcfButton>Import Employees</CcfButton> */}
          <CcfButton
            primary
            onClick={() => {
              setIsTableOpen(false);
            }}
            id="partnerAccessHeaderCreateUser"
          >
            Create User
          </CcfButton>
        </CcfBox>
      ) : (
        <CcfBox style={{ display: 'flex', gap: '5px' }}>
          <CcfButton
            onClick={() => {
              setIsTableOpen(true);
              setNewUserDetails(initialNewUserFeilds);
              setErrors({});
            }}
            id="partnerAccessCancelButton"
          >
            Cancel
          </CcfButton>
          <CcfButton
            primary
            onClick={() => {
              createUser();
            }}
            disabled={
              Object.keys(newUserDetails).some(
                (x: any) => newUserDetails['middleName'] !== '' && newUserDetails[x] === ''
              ) || Object.keys(errors).length > 0
            }
            id="partnerAccessCreateUserButton"
          >
            Create
          </CcfButton>
        </CcfBox>
      )}
    </Grid>
  );
}

export default PartnerAccessControlHeader;
